import { configureApp } from './configureApp';

export const { connectEntryToStore, store } = configureApp();
